export default {
      id: "check-demolist-usage",
      viewBox: "0 0 25 20",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#check-demolist-usage",
      toString: function () {
        return this.url;
      }
    }